import { createConfigExperiment } from '@pegasus/abtesting';

const PROJECT_ID = 'eb0e2e53-7935-4b42-bc43-fafb411dd8b6';
const AA_TEST_VARIANT = 'variant_aa_test';
const AA_TEST_CONTROL = 'control_aa_test';

export default createConfigExperiment({
    projectId: PROJECT_ID,
    variants: [AA_TEST_VARIANT, AA_TEST_CONTROL],
});
